"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSharedCouponResponseSchema = exports.getSharedCouponParamsSchema = void 0;
const zod_1 = require("zod");
const wallet_schemas_1 = require("../customer/wallet.schemas");
const profile_schemas_1 = require("../merchant/profile.schemas");
const api_schemas_1 = require("../base/api.schemas");
const timestamp_schemas_1 = require("../base/timestamp.schemas");
// ============================================
// PUBLIC SHARING SCHEMAS
// ============================================
// GET /shared/:shareCode - Params (Public preview, no auth)
exports.getSharedCouponParamsSchema = zod_1.z.object({
    shareCode: zod_1.z.string(),
});
// GET /shared/:shareCode - Response
exports.getSharedCouponResponseSchema = (0, api_schemas_1.dataResponseSchema)(zod_1.z.object({
    share_code: zod_1.z.string(),
    coupon: wallet_schemas_1.CouponEntitySchema.pick({
        title: true,
        description: true,
        coupon_type: true,
        coupon_value: true,
    }),
    merchant: profile_schemas_1.MerchantEntitySchema.pick({
        merchant_name: true,
        logo_url: true,
    }),
    sender_name: zod_1.z.string().nullable(), // Display name of sharer (privacy: nullable)
    expires_at: timestamp_schemas_1.timestampIsoSchema,
    is_expired: zod_1.z.boolean(),
    is_claimed: zod_1.z.boolean(),
}));
